module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "titlepage"
    }
  }, [_c('h1', {
    staticClass: "booktitle"
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("ice")]), _vm._v(" "), _c('span', {
    staticClass: "brown1"
  }, [_vm._v("cream")]), _vm._v(" "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("treats")])]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("easy ways to transform"), _c('br'), _vm._v("your favorite ice cream into"), _c('br'), _vm._v("spectacular desserts")]), _vm._v(" "), _c('h3', {
    staticClass: "author"
  }, [_vm._v("charity ferreira")]), _vm._v(" "), _c('p', {
    staticClass: "author2"
  }, [_c('em', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("photographs by leigh beisch")])])]), _vm._v(" "), _c('p', {
    staticClass: "publogo"
  }, [_c('img', {
    attrs: {
      "alt": "Chronicle Books logo",
      "src": "images/logo.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac32e732","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002titlepage.vue
// module id = 60
// module chunks = 0